import { Genre } from '@amzn/fire-tv-campaign-automation-service';

/**
 * Genre options for content classification, aligned with FireTVCreativeAssetCommonsModel Genre enum.
 */
export const GENRE_OPTIONS = [
  { name: 'Action', value: Genre.ACTION },
  { name: 'Comedy', value: Genre.COMEDY },
  { name: 'Horror', value: Genre.HORROR },
  { name: 'Romance', value: Genre.ROMANCE },
  { name: 'Thriller', value: Genre.THRILLER },
];
